export default __webpack_public_path__ + "static/media/Viking@3x.7697fea6.png";